import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { aceptarCookies } from '../../actions';
import './Footer.css';

class Footer extends Component {
  handleSubmitCookies = event => {
    event.preventDefault();

    this.props.aceptarCookies();
  }

  renderCookies() {
    if (this.props.cookie_apc === false) {
      const { t } = this.props;

      return (
        <footer className="contenedorCookies">
          <p className="textoCookies fontMed" style={{ display: 'inline' }}>{t('textosPie.cookies')} <a className="linkAzulAzulClaro" href={process.env.REACT_APP_URL_COOKIES} title={t('link.polCookies')}><span className="fontBold">{t('link.polCookies')}</span></a></p>
          <form method="post" onSubmit={this.handleSubmitCookies} style={{ display: 'inline', marginLeft: '5px' }}>
            <button id="botoncookies" name="AceptoCookies" type="submit" value="Acepto"><span className="fontBold fontMed">{t('textosPie.acepto')}</span></button>
          </form>
        </footer>
      );
    }

    return null;
  }

  render() {
    const { t } = this.props;

    return (
      // <object data="https://antarie.com/images/pie-web.svg" type="image/svg+xml" className="objectPie"></object>
      <>
        <img alt={t('imagenPie')} className="objectPie" src="https://antarie.com/images/pie-web.svg" title={t('imagenPie')} />

        <footer className="contenedor foot textoCentrado">
          <div className="contenedor">
            <div className="col-pxxxl-15 col-pxxl-7 col-pxl-3 col-pl-3 col-pm-2 col-ps-2 col-pxs-2 col-pxxs-2 hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs">&nbsp;</div>

            <div className="col-pxxxl-7 col-pxxl-6 col-pxl-4 col-pl-4 col-pm-4 col-ps-4 col-pxs-4 col-pxxs-4 col-xxl-4 col-xl-4 col-l-4 col-m-6 col-s-6 col-xs-6 col-xxs-6">
              <p className="textoPieG fontBold">{t('textosPie.servicios').toUpperCase()}</p>
              <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_DESARROLLO_WEB} title={t('link.desarrolloWeb')}>{t('link.desarrolloWeb').toUpperCase()}</a>
              <br />
              <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_DESARROLLO_APPS} title={t('link.desarrolloApps')}>{t('link.desarrolloApps').toUpperCase()}</a>
              <br />
              <a className="hidden-s hidden-xs hidden-xxs linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_SOLUCIONES_SOFTWARE} title={t('link.solucionesSoftware')}>{t('link.solucionesSoftware').toUpperCase()}</a>
              <a className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_SOLUCIONES_SOFTWARE} title={t('link.solucionesSoftware')}>{t('link.solSoftware').toUpperCase()}</a>
            </div>

            <div className="col-pxxxl-6 col-pxxl-6 col-pxl-6 col-pl-6 col-pm-4 col-ps-4 col-pxs-4 col-pxxs-4 col-xxl-4 col-xl-4 col-l-4 col-m-6 col-s-6 col-xs-6 col-xxs-6">
              <p className="textoPieG fontBold">{t('textosPie.tecnologias').toUpperCase()}</p>
              <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_MACHINE_LEARNING} title={t('link.aiMachineLearning')}>{t('link.aiMachineLearning').toUpperCase()}</a>
              <br />
              <a className="hidden-s hidden-xs hidden-xxs linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_TRANSFORMACION_DIGITAL} title={t('link.transformacionDigital')}>{t('link.transformacionDigital').toUpperCase()}</a>
              <a className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_TRANSFORMACION_DIGITAL} title={t('link.transformacionDigital')}>{t('link.transfDigital').toUpperCase()}</a>
              <br />
              <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_MIGRACION_NUBE} title={t('link.migracionNube')}>{t('link.migracionNube').toUpperCase()}</a>
            </div>

            <div className="col-pxxxl-7 col-pxxl-6 col-pxl-4 col-pl-4 col-pm-4 col-ps-4 col-pxs-4 col-pxxs-4 col-xxl-4 col-xl-4 col-l-4 hidden-m hidden-s hidden-xs hidden-xxs">
              <p className="textoPieG fontBold">{t('textosPie.recursos').toUpperCase()}</p>
              <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_DESCUBRE_ANTARIE} title={t('link.descubreAntarie')}>{t('link.descubreAntarie').toUpperCase()}</a>
              <br />
              <Link title={t('link.blog')} to="/"><span className="linkBlancoAzulClaro textoPie fontBold">{t('link.blog').toUpperCase()}</span></Link>
            </div>

            <div className="col-pxxxl-15 col-pxxl-7 col-pxl-3 col-pl-3 col-pm-2 col-ps-2 col-pxs-2 col-pxxs-2 hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs">&nbsp;</div>
          </div>

          <div className="contenedor margenCentralPie margenInferiorBig textoCentrado">
            <a className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l" href={process.env.REACT_APP_URL_HOME} title={t('imagenPie')}><img alt={t('imagenPie')} src="https://antarie.com/images/logo-blanco.png" style={{ width: '160px' }} title={t('imagenPie')} /></a>
            <p className="col-pxxxl-25 col-pxxl-16 col-pxl-10 col-pl-10 col-pm-8 col-ps-8 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-12 col-s-12 col-xs-12 col-xxs-12 fontBold firmaIzq">
              &copy; { new Date().getFullYear() } - {t('textosPie.empresa')}
              <br />
              <span className="fontBold">{t('contacto.email')}</span>
              <span className="fontBold">&nbsp;&nbsp;{t('contacto.telefono')}</span>
            </p>
            <div className="col-pxxxl-25 col-pxxl-16 col-pxl-10 col-pl-10 col-pm-8 col-ps-8 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 hidden-m hidden-s hidden-xs hidden-xxs firmaDer">
              <a href={process.env.REACT_APP_URL_HOME} title={t('logoPie')}><img alt={t('logoPie')} src="https://antarie.com/images/logo-blanco.png" style={{ width: '160px' }} title={t('logoPie')} /></a>
            </div>

            <p className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 hidden-m hidden-s hidden-xs hidden-xxs"><a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_AVISOS_LEGALES} title={t('link.avisosLegales')}>{t('link.avisosLegales').toUpperCase()}</a> | <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_COND_GEN} title={t('link.condicionesGenerales')}>{t('link.condicionesGenerales').toUpperCase()}</a> | <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_LOPD} title={t('link.proteccionDatosPer')}>{t('link.proteccionDatos').toUpperCase()}</a> | <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_COOKIES} title={t('link.polCookies')}>{t('link.polCookies').toUpperCase()}</a></p>

            <p className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l col-m-12 col-s-12 col-xs-12 col-xxs-12"><a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_AVISOS_LEGALES} title={t('link.avisosLegales')}>{t('link.legal').toUpperCase()}</a> | <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_COND_GEN} title={t('link.condicionesGenerales')}>{t('link.condGenerales').toUpperCase()}</a> | <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_LOPD} title={t('link.proteccionDatosPer')}>{t('link.LOPD')}</a> | <a className="linkBlancoAzulClaro textoPie fontBold" href={process.env.REACT_APP_URL_COOKIES} title={t('link.polCookies')}>{t('link.cookies').toUpperCase()}</a></p>
          </div>
        </footer>

        {this.renderCookies()}
      </>
    );
  }
}

const mapStateToProps = ({ app }) => {
  const { cookie_apc } = app;

  return { cookie_apc };
};

export default compose(
  connect(mapStateToProps, { aceptarCookies }),
  withTranslation('common')
)(Footer);
